import { render } from "./CustomHeaderCalendar.vue?vue&type=template&id=04602020"
import script from "./CustomHeaderCalendar.vue?vue&type=script&lang=js"
export * from "./CustomHeaderCalendar.vue?vue&type=script&lang=js"

import "./CustomHeaderCalendar.vue?vue&type=style&index=0&id=04602020&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__